import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="bg-background-100 py-14 md:py-20" aria-labelledby="faq-title">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-3">
              常见问题
            </span>
            <h2 id="faq-title" className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
              <a href="#faq-title">关于亚洲无码正版平台的常见疑问</a>
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
              我们整理了用户最常咨询的问题，帮助您快速了解亚洲无码正版内容平台的相关信息。
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                  aria-expanded={openIndex === index}
                >
                  <span className="font-medium text-sm text-foreground-900 pr-8">
                    {faq.question}
                  </span>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}